import { Injectable } from "@angular/core";
import { Adapter } from "../adapter";
import { LTSAEvergreen } from "./constants";


export class PlantLTSASearch {
    constructor(
        public plantLtsaId: string,
        public contractLength: string,
        public contractLengthDesc: string,
        public contractExpiration: string,
        public ltsaStatusId: string,
        public ltsaStatusDesc: string,
        public recordStatusId: string,
        public recordStatusDesc: string,
        public companyId: string,
        public companyName: string,
        public preferredContractor: string,
        public qcDate: string,
        public physAddressV1: string,
        public mailAddressV1: string,
        public plantId: string,
        public plantName: string,
        public offshoreBlockV1: string,
        public plantOwner: string
    ) { }
}

@Injectable({
    providedIn: 'root',
})
export class PlantLTSASearchAdapter implements Adapter<PlantLTSASearch> {
    adapt(item: any): PlantLTSASearch {


        return new PlantLTSASearch(
            item.PLANT_LTSA_ID, 
            item.CONTRACT_LENGTH,
            item.CONTRACT_LENGTH === LTSAEvergreen.Code ? LTSAEvergreen.Letter : item.CONTRACT_LENGTH, 
            item.CONTRACT_EXPIRATION,
            item.LTSA_STATUS_ID, 
            item.LTSA_STATUS_DESC, 
            item.RECORD_STATUS, 
            item.RECORD_STATUS_DESC, 
            item.COMPANY_ID, 
            item.COMPANY_NAME,
            item.PREFERRED_CONTRACTOR, 
            item.QC_DATE,
            item.PHYS_ADDRESS_V1, 
            item.MAIL_ADDRESS_V1,
            item.PLANT_ID, 
            item.PLANT_NAME, 
            item.OFFSHORE_BLOCK_V1,
            item.PLANT_OWNER
        );
    }
}


